/**
 * Shopify Forms RTL Fix
 * Fixes text alignment for inputs in Shopify Forms app shadow DOM.
 *
 * Issue: Shopify Forms app ignores data-forms-text-alignment for input fields.
 * Solution: Inject direction-aware styles into the shadow DOM using logical properties.
 */
(function() {
  'use strict';

  function fixShopifyFormsShadowDOM() {
    const formsEmbed = document.querySelector('shopify-forms-embed');
    if (!formsEmbed || !formsEmbed.shadowRoot) return false;

    // Check if fix already applied
    if (formsEmbed.shadowRoot.querySelector('#rtl-fix-styles')) return true;

    const isRTL = document.documentElement.dir === 'rtl';

    // Inject direction-aware styles into shadow DOM
    const style = document.createElement('style');
    style.id = 'rtl-fix-styles';
    style.textContent = `
      /* Align inputs/textareas to match document direction */
      input,
      textarea {
        text-align: start !important;
      }

      /* Align floating labels to match document direction */
      label {
        text-align: start !important;
        inset-inline-start: 15px !important;
        inset-inline-end: auto !important;
      }

      /* Align field containers to match document direction */
      div[class*="formFieldContainer"] {
        text-align: start !important;
        direction: ${isRTL ? 'rtl' : 'ltr'};
      }
    `;
    formsEmbed.shadowRoot.appendChild(style);
    return true;
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixShopifyFormsShadowDOM);
  } else {
    fixShopifyFormsShadowDOM();
  }

  // Re-run after delays for async-loaded forms
  setTimeout(fixShopifyFormsShadowDOM, 1000);
  setTimeout(fixShopifyFormsShadowDOM, 2000);

  // Also observe for dynamically added forms
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        fixShopifyFormsShadowDOM();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
